import React,{useState,useContext} from 'react';
// useEffect,
// import ReactTooltip from 'react-tooltip';
import { Button, Spinner, Dropdown, DropdownButton } from 'react-bootstrap';
// , OverlayTrigger, Tooltip, Nav ListGroup, Container, Row, Col, Modal,
import {  withRouter } from "react-router-dom";
// Link,
import { apiUrl, user_Status, user_Status_Ver } from "Api/Api";
// , myHeaders_Auth_With_Cache_Control
//import { HubspotForm } from "Api/HubspotApi.js";

import axios from "axios";

// import { local_routes } from 'utils/Routes';

//import Select from 'react-select';

import UserContext from 'store/UserContext';

import SignupModal from 'components/Modals/SignupModal';
import VerificationModal from 'components/Modals/VerificationModal';

import { assembleNickname } from "utils/Helper"
// get_current_unix_stamp, 
//import { slugify } from 'utils/Helper';

//import { useForm } from 'react-hubspot'

//import './style.css';
import { stripe_prices } from 'utils/stripe_plans';
import {loadStripe} from '@stripe/stripe-js';
//loadStripe.setLoadParameters({advancedFraudSignals: false})
const stripePromise = loadStripe(process.env.REACT_APP_PK_STRIPE_KEY);

function TipButton (props) {
  const user_context = useContext(UserContext);
  
  const stripe_tip_prices_array = Object.values(stripe_prices[process.env.REACT_APP_PK_ENV]);
  //const stripe_price_obj = Object.values(stripe_prices[process.env.REACT_APP_PK_ENV])[0];
  //const stripe_price_id = Object.keys(stripe_prices[process.env.REACT_APP_PK_ENV])[0];
  //let tmp_amount = stripe_price_obj.amount / 100;
  //const price_display = (stripe_price_obj.amount / 100).toLocaleString("en-US", {style:"currency", currency:"USD", minimumFractionDigits: 0, maximumFractionDigits: 2});

  const nickname = assembleNickname(props.entity_info);
  
  const button_variant = 'pkprimary';

  /*
  const button_info_map = {
    'tip': {
      button_text: 'Tip '+price_display,
      button_tooltip: 'Click to Tip '+nickname,
      button_variant: 'pkprimary',
      button_icon: <i className="fa fa-gratipay"/>
    },
  };
  */
  
  //const [followed,setFollowed] = useState(props.followed);
  //const [button_info,setButtonInfo] = useState(props.followed ? button_info_map['followed'] : button_info_map['unfollowed']);
  //const [button_info,setButtonInfo] = useState(button_info_map['tip']);
  const [loading,setLoading] = useState(false);
  const [show_signup_modal,setShowSignupModal] = useState(false);
  const [verification_modal_show,setVerificationModalShow] = useState(false);

  //console.log("FollowButton",props);

  async function tip (stripe_price_id) {
    console.log("tip",stripe_price_id,stripe_prices);
    //let price_id = Object.keys(stripe_prices[process.env.REACT_APP_PK_ENV])[0];  
    //let plan_id = plan_info.plan_id;
    let price_display = stripe_prices[process.env.REACT_APP_PK_ENV][stripe_price_id].nickname+' for '+nickname;
    
    if (!user_context.user_info.entity_uuid) {
      console.error("NO user!");
      window.localStorage.setItem('loginOrigin',props.location.pathname);
      setShowSignupModal(true);
      return;
    }
    if (user_context.user_info.status_code !== 1) {
      console.error("NO user is not verified!");
      setVerificationModalShow(true);
      return;
    }
    
    let stripe_object = await stripePromise;
    
    if (!stripe_object) {
      console.error("NO stripe object!");
      return;
    }
    setLoading(true);
    let params = {
      cancel_url: window.location.href,
      //success_url: window.location.origin+local_routes.accountsettings+'?refresh',
      success_url: window.location.href,
      stripe_plan_id: stripe_price_id,
      stripe_checkout_mode: 'payment',
      tip_entity_uuid: props.entity_info.entity_uuid,
      tip_entity_type: props.entity_info.entity_type,
      stripe_checkout_description: price_display
    };
    let checkout_session_id_response = await axios.post(`${apiUrl}users/${user_context.user_info.entity_uuid}/getCheckoutSessionId`, params);
    console.log("Got session ID from stripe",checkout_session_id_response.data);
    await stripe_object.redirectToCheckout({
      sessionId: checkout_session_id_response.data.checkout_session_id
    });
    console.log("What now?");
  }

  /*
  async function followUnfollow () {
    console.log("followUnfollow",followed,props.entity_info);
    
    if (!user_context.user_info.entity_uuid) {
      window.localStorage.setItem('loginOrigin',props.location.pathname);
      props.history.push('/login');
      return;
    }
    
    let favorited_time;
    if (followed) {
      favorited_time = -1; // for unfollow
      setButtonInfo(button_info_map.unfollowed);
    } else {
      favorited_time = get_current_unix_stamp();
      setButtonInfo(button_info_map.followed);
    }
    
    setFollowed(!followed);
    
    let patch_obj = {
      [props.entity_info.entity_type+'.audience']: [
        {
          entity_uuid: props.entity_info.entity_uuid,
          xref_data: {
            favorited_time
          }
        }
      ]
    };
    
    await axios.patch(`${apiUrl}users/${user_context.user_info.entity_uuid}`,patch_obj);
    
    // are we friends now? let's check
    let friends_results = await axios.get(`${apiUrl}users/${user_context.user_info.entity_uuid}/users.audience/${props.entity_info.entity_uuid}`, myHeaders_Auth_With_Cache_Control);
    if (friends_results.data.friended_time) {
      // yes we are friends!
      if (props.friendsOrNot) {
        props.friendsOrNot(true);
      }
    } else {
      if (props.friendsOrNot) {
        props.friendsOrNot(false);
      }
    }
  }
  */

  if (!props.entity_info.stripe_account_tip_ready) {
    return (
      <React.Fragment>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      {loading ?
        <Button
          variant={button_variant}
          style={{...props['style']}}
          disabled
        >
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
            style={{ marginLeft: '15px', marginRight: '15px' }}
          />
          <span className="sr-only">Loading...</span>
        </Button>
      :
        <DropdownButton
          title={<span>Tip <i className="fa fa-gratipay"/></span>}
          //data-place='top'
          //data-tip='Tip this Creator!'
          variant={button_variant}
          style={props['style']}
          className="dropdown d-inline-block"
        >
          { Object.keys(stripe_prices[process.env.REACT_APP_PK_ENV]).map( (stripe_price_id) => {
            return (
              <Dropdown.Item
                key={stripe_price_id}
                onClick={() => tip(stripe_price_id)}
              >
                {stripe_prices[process.env.REACT_APP_PK_ENV][stripe_price_id].nickname}
              </Dropdown.Item>
            );
          })}
        {/*
        <Button
          style={props['style']}
          variant={button_info.button_variant}
          data-place='top'
          data-tip={button_info.button_tooltip}
          onClick={tip}
        >
          {button_info.button_text} {button_info.button_icon}
          <ReactTooltip />
        </Button>
        */}
        </DropdownButton>

      }      
        { !user_Status &&
          <SignupModal
            show={show_signup_modal}
            onHide={() => setShowSignupModal(false)}
            reload={true}
          >
          </SignupModal>
        }
        
        { user_Status_Ver !== "1" &&
          <VerificationModal
            show={verification_modal_show}
            onHide={() => setVerificationModalShow(false)}
          />
        
        }
      
    </React.Fragment>
  );
}

export default withRouter(TipButton);